import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the customIndicators state domain
 */

const selectSynchronizationDomain = (state) =>
  state.get("synchronization", initialState)

/**
 * Other specific selectors
 */

/**
 * Default selector used by CustomIndicators
 */

const makeSelectSynchronization = () =>
  createSelector(selectSynchronizationDomain, (substate) => substate.toJS())

export const makeSelectIsLoadingSynchronizations = () =>
  createSelector(selectSynchronizationDomain, (state) =>
    state.get("isLoadingSynchronizations")
  )

export const makeSelectSynchronizations = () =>
  createSelector(selectSynchronizationDomain, (state) =>
    state.get("synchronizations")
  )

export default makeSelectSynchronization
export { selectSynchronizationDomain }
